// Rappel local : aucune adresse de destinataire ni donnée de la carte dans le calendrier.
export function calendrierAssurance(echeance: string, jours = 30): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(echeance) || ![7, 30, 60].includes(jours)) throw new Error('Date ou délai invalide.');
  const date = new Date(`${echeance}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== echeance) throw new Error('Date invalide.');
  const lendemain = new Date(date.getTime() + 86400000).toISOString().slice(0, 10).replaceAll('-', '');
  const jour = echeance.replaceAll('-', '');
  return [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Ekera//Rappel assurance//FR', 'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT', `UID:renouvellement-${jour}-${jours}@ekera.local`,
    `DTSTAMP:${new Date().toISOString().replaceAll('-', '').replaceAll(':', '').slice(0, 15)}Z`,
    `DTSTART;VALUE=DATE:${jour}`, `DTEND;VALUE=DATE:${lendemain}`,
    'SUMMARY:Renouvellement assurance - dossier à préparer',
    'DESCRIPTION:Relire et valider le dossier dans Documents. Transmission par l’entreprise.',
    'BEGIN:VALARM', `TRIGGER:-P${jours}D`, 'ACTION:DISPLAY',
    'DESCRIPTION:Préparer le dossier de renouvellement assurance', 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR', '',
  ].map((ligne) => {
    let resultat = '', longueur = 0;
    for (const lettre of ligne) {
      const taille = new TextEncoder().encode(lettre).length;
      if (longueur + taille > 75) { resultat += '\r\n '; longueur = 1; }
      resultat += lettre; longueur += taille;
    }
    return resultat;
  }).join('\r\n');
}
